import { render, staticRenderFns } from "./RelationSetting.vue?vue&type=template&id=6ccf7bc1&scoped=true"
import script from "./RelationSetting.vue?vue&type=script&lang=js"
export * from "./RelationSetting.vue?vue&type=script&lang=js"
import style0 from "./RelationSetting.vue?vue&type=style&index=0&id=6ccf7bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf7bc1",
  null
  
)

export default component.exports